import { SingleSelectOption } from 'uiComponents/input'
import { t } from 'translations'

export const getGoogleTTDCategories = (): SingleSelectOption[] => [
    { name: t('channels.googleTTD.categories.adultsOnly'), value: 'adults-only' },
    { name: t('channels.googleTTD.categories.animals'), value: 'animals' },
    { name: t('channels.googleTTD.categories.audioGuide'), value: 'audio-guide' },
    { name: t('channels.googleTTD.categories.beaches'), value: 'beaches' },
    { name: t('channels.googleTTD.categories.bikeTours'), value: 'bike-tours' },
    { name: t('channels.googleTTD.categories.boatTours'), value: 'boat-tours' },
    { name: t('channels.googleTTD.categories.cityCards'), value: 'city-cards' },
    { name: t('channels.googleTTD.categories.classes'), value: 'classes' },
    { name: t('channels.googleTTD.categories.dayTrips'), value: 'day-trips' },
    { name: t('channels.googleTTD.categories.familyFriendly'), value: 'family-friendly' },
    { name: t('channels.googleTTD.categories.fastTrack'), value: 'fast-track' },
    { name: t('channels.googleTTD.categories.food'), value: 'food' },
    { name: t('channels.googleTTD.categories.guidedTours'), value: 'guided-tours' },
    { name: t('channels.googleTTD.categories.history'), value: 'history' },
    { name: t('channels.googleTTD.categories.hopOnHopOff'), value: 'hop-on-hop-off' },
    { name: t('channels.googleTTD.categories.literature'), value: 'literature' },
    { name: t('channels.googleTTD.categories.liveMusic'), value: 'live-music' },
    { name: t('channels.googleTTD.categories.nightlife'), value: 'nightlife' },
    { name: t('channels.googleTTD.categories.outdoors'), value: 'outdoors' },
    { name: t('channels.googleTTD.categories.privateTours'), value: 'private-tours' },
    { name: t('channels.googleTTD.categories.romantic'), value: 'romantic' },
    { name: t('channels.googleTTD.categories.selfGuided'), value: 'self-guided' },
    { name: t('channels.googleTTD.categories.smallGroupTours'), value: 'small-group-tours' },
    { name: t('channels.googleTTD.categories.sports'), value: 'sports' },
    { name: t('channels.googleTTD.categories.themeParks'), value: 'theme-parks' },
    { name: t('channels.googleTTD.categories.walkingTours'), value: 'walking-tours' },
    { name: t('channels.googleTTD.categories.wheelchairAccessible'), value: 'wheelchair-accessible' },
]
